import type { SVGProps } from "react";
// generated from Link.svg — do not edit manually
// prettier-ignore
export default function Link(props: SVGProps<SVGSVGElement>) {
  return (<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
  <path d="M9.5001 14.5L14.5001 9.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/>
  <path d="M16.8463 14.6095L19.4558 12C21.5147 9.9411 21.5147 6.603 19.4558 4.5441C17.397 2.4852 14.0588 2.4852 12 4.5441L9.3904 7.1537M14.6095 16.8463L12 19.4558C9.9411 21.5147 6.603 21.5147 4.5442 19.4558C2.4853 17.3969 2.4853 14.0588 4.5442 12L7.1537 9.3904" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/>
</svg>);
}
